import React from 'react'
import {useTradeContext} from 'Src/contexts/TradeContext'
import {formatValue} from 'Src/utilities/DataReformatters'
import {trans} from 'Src/utilities/Helpers'

const TradeCompleteHeader = () => {
  const {TradeVehicleValue} = useTradeContext()

  return (
    <div className="tw-mb-5 tw-border-2 tw-border-brand-success tw-px-4 tw-py-2 tw-text-center">
      <h2 className="h2 tw-mb-2 !tw-text-brand-success">Your Trade has been added!</h2>
      <div className="tw-m-2 tw-text-brand-body_text">
        {trans('Your Estimated Total Trade')}: {formatValue(TradeVehicleValue)}
      </div>
      <p className="tw-mb-1 tw-text-sm tw-font-medium tw-text-brand-body_text--muted">
        {trans('trade_int.not_an_offer_contingent_on_inspection')}
      </p>
    </div>
  )
}

export default TradeCompleteHeader
